import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    en: require('./assets/localization/en.json'),
    nl: require('./assets/localization/nl.json')
};

const i18n = new VueI18n({
    locale: 'nl',
    messages,
});

export default i18n;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/localization.ts